import util from './checkDataType'
import i18n from '../i18n/i18n'
export let hasSpecialChar = (rule, value, callback) => {
  // let regEn = /[`!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
  let regCn = /[~！@#￥%……&*？[\]{}']/im
  if (regCn.test(value)) {
    callback('请不要使用~！@#￥%……&*？[]{}特殊字符')
  }
  callback()
}
export let trimData = (data) => {
  if (util.isString(data)) {
    return data.trim()
  } else if (util.isObject(data) || util.isArray(data)) {
    Object.keys(data).map((item) => {
      // return trimData(data[item])
      data[item] = trimData(data[item])
    })
    return data
  }
}
// 必须是1-100的数字
export let isNumberLt100 = (rule, value, callback) => {
  // let regEn = /[`!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
  let reg = /^([1-9][0-9]?)$/
  if (reg.test(value)) {
    callback()
  }
  callback(i18n.t('alarm.heartRateThresholdMin'))
}

// 必须是大于1800的数字
export let isNumberGt1800 = (rule, value, callback) => {
  // let regEn = /[`!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
  // let reg = /^([1-9][0-9]?)$/
  if (value * 1 > 1800) {
    callback()
  } else {
    callback('输入值需大于1800')
  }
}

export let isNumberGt60 = (rule, value, callback) => {
  // let regEn = /[`!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
  // let reg = /^([1-9][0-9]?)$/
  if (value * 1 >= 60) {
    callback()
  } else {
    callback('输入值需大于等于60')
  }
}

// 必须是100-200的数字
export let isNumber100To200 = (rule, value, callback) => {
  // let regEn = /[`!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
  // let reg = /^([1-9][0-9]?)$/
  if (value * 1 >= 100 && value * 1 <= 200) {
    callback()
  } else {
    callback(i18n.t('alarm.heartRateThresholdMax'))
  }
}



export default {
  hasSpecialChar,
  isNumberLt100, 

}